module.exports = __webpack_public_path__ + "static/media/5.16befff3.jpg";